module.exports = __webpack_public_path__ + "static/number-24fd69de66e779ff9a7e0ceced0844f4.png";